module.exports = __webpack_public_path__ + "img/neckline binding width.43aa2dd0.png";